import { Box } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Tabbar from "../Components/Account/Tabbar";
import withClient from "../routing/withClient";
import isAllowed from "../routing/isAllowed";

function Profile() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === "/profile") {
      navigate("/profile/account");
    }

  }, [pathname]);

  return (
    <>
      <Tabbar />
      <Box marginLeft="250px" paddingRight={"10"} as="main">
        <Outlet />{" "}
      </Box>
      ;
    </>
  );
}

export default isAllowed(Profile);
